"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "FRIDAY": "piątek",
    "MONDAY": "poniedziałek",
    "SATURDAY": "sobota",
    "SUNDAY": "niedziela",
    "THURSDAY": "czwartek",
    "TUESDAY": "wtorek",
    "WEDNESDAY": "Środa",
    "and": "i",
    "day_few": "dni",
    "day_many": "dni",
    "day_one": "dzień",
    "day_other": "dni",
    "day_plural": "dni",
    "freeOfCharge": "Darmowe",
    "hour_few": "godziny",
    "hour_many": "godzin",
    "hour_one": "godzina",
    "hour_one_plural": "godzin",
    "hour_other": "godzin",
    "minute_few": "minuty",
    "minute_many": "minut",
    "minute_one": "minuta",
    "minute_other": "minut",
    "ocpiRestrictionsAfterDuration": "Powyżej {{minDuration}}",
    "ocpiRestrictionsBetweenDuration": "Pomiędzy {{minDuration}} a {{maxDuration}}",
    "ocpiRestrictionsFirstDuration": "Pierwsze {{maxDuration}}",
    "ocpiRestrictionsKwhAbove": "Gdy zużycie energii powyżej {{minKwh}}",
    "ocpiRestrictionsKwhBetween": "Gdy zużycie energii pomiędzy {{minKwh}} a {{maxKwh}}",
    "ocpiRestrictionsKwhLessThan": "Gdy zużycie energii mniejsze niż {{maxKwh}}",
    "session": "sesja",
    "theDay_few": "dni",
    "theDay_many": "dni",
    "theDay_one": "dzień",
    "theDay_other": "dni",
    "theHour_few": "godziny",
    "theHour_many": "godzin",
    "theHour_one": "godzina",
    "theHour_other": "godzin",
    "theMinute_few": "minuty",
    "theMinute_many": "minut",
    "theMinute_one": "minuta",
    "theMinute_other": "minut"
};
